import { get, isObject } from "lodash";
import { DialogStatus } from "./types";
import { isNotEmpty } from "utils/validate";
export const isFormChanged = ({ valid, dirty }, id) => {
    return valid && (!isNotEmpty(id, true) || id === -1 || dirty);
};
export const someFormFieldModified = ({ modified }, omittedFields) => !!modified &&
    Object.entries(modified).some(([key, value]) => !omittedFields?.includes(key) && Boolean(value));
const countErrors = (errors) => {
    if (isObject(errors)) {
        return Object.values(errors).reduce((accum, item) => accum + countErrors(item), 0);
    }
    return 1;
};
/**
 * partial validation
 * https://dev.azure.com/sartorius-bps/Process%20Insights/_workitems/edit/89067
 */
export const isFormValid = ({ valid, active, errors, }) => {
    const errorCount = countErrors(errors);
    if (!valid && active && errorCount === 1 && get(errors, active)) {
        return true;
    }
    return valid;
};
export const isDialogOpened = (status) => status === DialogStatus.OPENED || status === DialogStatus.PENDING;
export const isDialogInPending = (status) => status === DialogStatus.PENDING;
